module.exports = __webpack_public_path__ + "static/media/template1.d70dc743.png";